import React, { useEffect, useState } from "react";
import { ResponseFormating } from "../../Functions/ResponseFormate";
import ShowImageComponent from "./ShowImageComponent";
import ModalComponent from "../ModalComponent/Modal";
import nodata from "../../assets/images/no-data.png";
import DataTable from "../DataTable/DataTable";
import { Table, TableColumnProps } from "@arco-design/web-react";

function ExtractedData({ responseData, selectedMenu, selectedSide }) {
  const [formatedResponse, setFormatedResponse] = useState(null);
  const [nestedDataSet, setNestedDataSet] = useState({});
  // //console.log("asasa",JSON.parse(responseData.result));

  useEffect(() => {
    console.log("nestedDataSet", nestedDataSet);
    //.log("formatedResponse", formatedResponse);
  }, [nestedDataSet]);

  // Step 2: Implement a function to convert the state data to text format
  const convertToText = () => {
    const textData = Object.entries(formatedResponse)
      .map(([key, value]) => `${key}: ${value}`)
      .join("\n");

    return textData;
  };

  // Step 3: Add a download button that triggers the download function
  const handleDownload = () => {
    const textData = convertToText();
    const blob = new Blob([JSON.stringify(responseData)], {
      type: "text/plain",
    });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "data.txt";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const columns = [
    {
      title: "Item name",
      dataIndex: "name",
    },
    {
      title: "Price",
      dataIndex: "salary",
    },
    {
      title: "Discount",
      dataIndex: "address",
    },
    {
      title: "Qty",
      dataIndex: "email",
    },
    {
      title: "total",
      dataIndex: "number",
    },
  ];

  const data = [
    {
      key: "1",
      name: "Jane Doe",
      salary: 23000,
      address: "20",
      email: "3",
      number: "22",
    },
    {
      key: "2",
      name: "Alisa Ross",
      salary: 25000,
      address: "10",
      email: "2",
      number: "22",
    },
    {
      key: "3",
      name: "Kevin Sandra",
      salary: 22000,
      address: "0",
      email: "2",
      number: "22",
    },
    {
      key: "4",
      name: "Ed Hellen",
      salary: 17000,
      address: "0",
      email: "2",
      number: "22",
    },
    {
      key: "5",
      name: "William Smith",
      salary: 27000,
      address: "0",
      email: "2",
      number: "22",
    },
  ];

  useEffect(() => {
    handleResponse();
    //console.log(responseData)
  }, [responseData]);

  const handleResponse = async () => {
    //
    try {
      // if (!responseData?.result.includes("API calls for today exceeded.")) {
      let data;
      let parsedResult;
      try {
        // Attempt to parse responseData.result as JSON
        let parses = responseData.message
          ? responseData.message
          : responseData.result;
        if (responseData.message) {
          parsedResult = JSON.parse(parses);
        } else {
          parsedResult = JSON.parse(parses).message;
        }
        // let parsedResult = JSON.parse(responseData.message);
        if (typeof parsedResult == "string") {
          parsedResult = JSON.parse(parsedResult);
        }
        data = parsedResult;
      } catch (error) {
        data = null;
        // console.error("Error parsing JSON:", error);
      }
      let resultData = await ResponseFormating(
        selectedMenu,
        data,
        selectedSide
      );
      console.log("dsfds", resultData);
     
      // //console.log("adsa", formatedResponse?.faceImage);
      // } else {
      //   setFormatedResponse(null);
      // }
      if(selectedMenu == "AOFEXTRACTION"){
        const nestedData = {};
        for (const key in resultData.data) {
          const ParentKey = resultData.data[key];
          if (typeof ParentKey.value === "object") {
            nestedData[key] = ParentKey;
            delete resultData.data[key];
          } 
        }
        setNestedDataSet(nestedData)
      }
      setFormatedResponse(resultData);
    } catch (err) {
      // //console.log(err);
    }
  };
  const renderNestedData = () => {
    return (
      <>
        {selectedMenu === "AOFEXTRACTION" && nestedDataSet && Object.keys(nestedDataSet).length > 0 ? (
          Object.entries(nestedDataSet).map(([id, data]) => (
            <div className="pt-3" key={id}>
              <div className="row">
              <h1 className="bg_light4 font_14 fw_500 p-2 rounded-1 mb-0">{data.key}</h1>
                {Object.entries(data.value).map(([subKey, subValue], subIndex) => (
                  <div className="col-12 py-2 document_values pb-0 pb-sm-2">
                    <div className="row" key={subIndex}>
                      <div className="col-12 font_500 col-md-6 text_gray8  text-capitalize">{subKey.replace(/_/g, " ")}</div>
                      <div className="col-12 col-md-6 pt-1 pt-sm-0 mb-3 mb-sm-0">
                        <div className="d-flex justify-content-start ">
                            <div className="text_master2 fw_600 word_break text-start ">
                            {subValue}
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        ) : (
            <></>
        )}
      </>
    );
  };

  return (
    <div className="extracted_data_section pb-3 overflow-auto scrollbar1 px-0 px-md-3 px-md-0 position-relative">
      <div className="pt-3 pt-md-0">
        <div
          onClick={handleDownload}
          style={{ right: "10px" }}
          className={`${
           ["IMAGETOJSON","TRANSCOMPDFEXTRATION"].includes( selectedMenu) ? "d-block" : "d-none"
          }  bg_master2 position-absolute cursor-pointer px-3 py-2 rounded`}
        >
          <i class="fas fa-file-download font_16 text-white"></i>
        </div>

        <h2 className="font_16  fw-bold mb-3 text-center pt-2 mb-2">
          Extracted data
        </h2>
      </div>
      <div className="d-flex justify-content-center ">
        {(formatedResponse?.faceImage || formatedResponse?.faceImage) && (
          <ShowImageComponent
            image={[
              formatedResponse?.faceImage,
              formatedResponse?.signImage,
            ].filter((itm) => itm)}
            bottomName={["FACE IMAGE", "SIGN IMAGE"]}
          />
        )}
      </div>

      <div className="px-3  pt-3 pb-1 font_13">
        <div className="">
          <div className="row">
            <div className="col-12">
              {formatedResponse?.data?.length > 0 && (
                <div className="row mb-2 d-none d-md-flex">
                  <div className="col-6">
                    <h2 className="font_18 font_600">Fields</h2>
                  </div>
                  <div className="col-6">
                    <h2 className="font_18 font_600 ">Values</h2>
                  </div>
                </div>
              )}
            </div>
            {formatedResponse?.data?.length > 0 ? (
              formatedResponse?.data?.map((itm, index) => (
                <div
                  key={index}
                  className="col-12 py-2 document_values pb-0 pb-sm-2"
                >
                  <div className="row">
                    <div className="col-12 font_500 col-md-6 text_gray8  text-capitalize">
                      {itm.key}
                    </div>
                    <div className="col-12 col-md-6 pt-1 pt-sm-0 mb-3 mb-sm-0">
                      <div className="d-flex justify-content-start ">
                        <span className="text_master2 fw_600 word_break text-start ">
                          {itm.value}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="d-flex flex-column align-items-center mt-0 mt-md-5">
                <img
                  src={nodata}
                  className="no_data_thumbnail object_fit_contain"
                />
                <h4 className="text_gray7 font_16 mt-3">
                  {" "}
                  Unable To Process Data
                </h4>
              </div>
            )}
              {renderNestedData()}
            {/* invoice-ocr-bill-table */}

            {/* <div className="arco_table2">
              <Table columns={columns} data={data} />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExtractedData;
